<script setup>
import {ref} from "vue";
import enterprisesService from "@/services/enterprises.service";

const emit = defineEmits(['deleted', 'convert']);

const showModal = ref(false);
const enterpriseId = ref(0);
const relations = ref([]);
const hasStartupAccount = ref(false);
const loaded = ref(false);
const deleting = ref(false);

async function getData() {
    const {data} = await enterprisesService.getRelations(enterpriseId.value);

    relations.value = data.relations;
    hasStartupAccount.value = data.has_startup_account;
    loaded.value = true;
}

async function deleteEnterprise() {
    if (confirm("Delete enterprise?")) {
        deleting.value = true;
        await enterprisesService.delete(enterpriseId.value);

        emit("deleted");
        deleting.value = false;
        showModal.value = false;
    }
}

function convert() {
    emit('convert', enterpriseId.value);
    showModal.value = false;
}

function handleClose(event) {
    if (deleting.value) {
        event.preventDefault();
    }
}

function open(id) {
    loaded.value = false;
    relations.value = [];
    enterpriseId.value = id;
    showModal.value = true;
    getData()
}

defineExpose({
    open
});
</script>

<template>
    <b-modal v-model="showModal" :hide-footer="true" modal-class="modal-w-md" title="Enterprise Relations" @hide="handleClose">
        <div class="pb-3">
            <div v-for="relationType in relations" :key="relationType.name">
                <h5 class="heading5 heading5--secondary">{{relationType.name}}: {{relationType.count}}</h5>
            </div>

            <div v-if="loaded" class="text-center">
                <b-button :disabled="deleting" variant="danger" class="mt-3 w-100 w-sm-auto" size="lg" @click="deleteEnterprise">
                    <template v-if="deleting">
                        Deleting...
                    </template>
                    <template v-else>
                        Delete Enterprise
                    </template>
                </b-button>

                <b-button
                    v-if="!hasStartupAccount"
                    variant="primary"
                    class="mt-3 ml-sm-2 w-100 w-sm-auto"
                    size="lg"
                    @click="convert"
                >
                    Convert to Startup
                </b-button>
            </div>
        </div>
    </b-modal>
</template>

<style scoped>

</style>
